import React from 'react';
import {connect} from 'react-redux';

import {ANALYTICS_MODULE} from 'analytics/AnalyticsTypes';
import {Tag} from 'folder-items/FileConstants';
import {BenchlingDispatch} from 'redux-stores/Store';
import SchemaTagInputs from 'schemas/tags/SchemaTagInputs';
import * as TagUtil from 'schemas/tags/TagUtil';
import {ButtonStyle} from 'ui-library/buttons/Button';
import Modal from 'ui-library/modals/Modal';

import {ServerUIRequestTask, UIRequestTask} from './RequestTaskConstants';
import {createRequestTask} from './RequestTaskReduxActions';

export interface CreateRequestTaskModalProps {
  createRequestTask: (requestId: string, requestTask: ServerUIRequestTask) => Promise<void>;
  initialRequestTask: UIRequestTask;
  requestId: string;
  onRequestClose: () => void;
  onRequestSubmit: () => void;
}

interface State {
  isSaving: boolean;
  requestTask: UIRequestTask;
}

class CreateRequestTaskModal extends React.Component<CreateRequestTaskModalProps, State> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any

  override state: State = {isSaving: false, requestTask: this.props.initialRequestTask};

  _handleSubmit = async (): Promise<void> => {
    if (!TagUtil.areTagsValidAndNotify(this.state.requestTask.tags)) {
      return;
    }
    this.setState({isSaving: true});
    try {
      await this.props.createRequestTask(this.props.requestId, {
        ...this.state.requestTask,
        tags: TagUtil.getTagsToSet(this.state.requestTask.tags),
      });
      this.props.onRequestSubmit();
    } catch (e) {
      this.setState({isSaving: false});
      throw e;
    }
  };

  _handleUpdateTags = (newTags: Array<Tag>): void => {
    this.setState({requestTask: {...this.state.requestTask, tags: newTags}});
  };

  override render(): JSX.Element {
    return (
      <Modal
        title="Create task"
        onRequestClose={this.props.onRequestClose}
        buttons={[
          {
            key: 'create',
            disabled: this.state.isSaving,
            onClick: this._handleSubmit,
            style: ButtonStyle.PRIMARY,
            submit: true,
            text: this.state.isSaving ? 'Creating...' : 'Create',
          },
        ]}
        analyticsModule={ANALYTICS_MODULE.REQUESTS}
        analyticsModalType="create_request_task"
      >
        <SchemaTagInputs
          itemLinkAllowed={true}
          isCreating={true}
          isWritable={true}
          onUpdateTags={this._handleUpdateTags}
          tags={this.state.requestTask.tags}
        />
      </Modal>
    );
  }
}

function mapDispatchToProps(dispatch: BenchlingDispatch): {
  createRequestTask: (requestId: string, requestTask: ServerUIRequestTask) => void;
} {
  return {
    createRequestTask(requestId: string, requestTask: ServerUIRequestTask): void {
      // file is the JSON of a fileSummary that is surfaced from StandaloneDataTableAddSampleModal's search
      // component, which does not automatically get cached in a store, so we do that now manually.
      dispatch(createRequestTask(requestId, requestTask));
    },
  };
}

export default connect(null, mapDispatchToProps)(CreateRequestTaskModal) as React.ComponentType<
  Omit<CreateRequestTaskModalProps, 'createRequestTask'>
>;
